import React, { useEffect, useState } from 'react';
import { db } from "../firebaseConfig";
import { collection, getDocs } from 'firebase/firestore';

const FixDataComponent = () => {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIssues = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'common_issues'));
        const data = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setIssues(data);
      } catch (error) {
        console.error('Error fetching issues:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchIssues();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-2">🔧 Common Issues (Raw JSON)</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto">
          {JSON.stringify(issues, null, 2)}
        </pre>
      )}
    </div>
  );
};

export default FixDataComponent;
